// @flow

import type { Action } from "redux-action";
import { beginRequest, completeRequest } from "@store/utils";

import type { ShiftPatternsState } from "./types";

const startRequest = beginRequest(["requestsInProgress"]);

const finishRequest = completeRequest(["requestsInProgress"]);

export const onLoad = (state: ShiftPatternsState) => () => startRequest(state);

export const onLoaded = (state: ShiftPatternsState) => () => finishRequest(state);

export const onError = (state: ShiftPatternsState) => ({ payload }: Object) => ({
  ...finishRequest(state),
  error: payload,
});

// Get Shift Patterns

export const onUpdateShiftPattern = (state: ShiftPatternsState) => () => startRequest(state);
export const onUpdateShiftPatternSuccess = (state: ShiftPatternsState) => () =>
  finishRequest(state);
export const onUpdateShiftPatternError = (state: ShiftPatternsState) => () => finishRequest(state);

export const onGetShiftPatterns = (state: ShiftPatternsState) => () => ({
  ...state,
  isLoading: true,
});

export const onGetShiftPatternsSuccess = (state: ShiftPatternsState) => (action: *) => ({
  ...state,
  list: action.payload,
  isLoading: false,
});

export const onGetShiftPatternsError = (state: ShiftPatternsState) => ({ payload }: Object) => ({
  ...state,
  isLoading: false,
  success: false,
  error: payload,
});

export const onGetTotalShiftPatterns = (state: ShiftPatternsState) => () => startRequest(state);

export const onGetTotalShiftPatternsSuccess = (state: ShiftPatternsState) => (action: *) => {
  return {
    ...state,
    totalList: action.payload,
    error: null,
    requestsInProgress: --state.requestsInProgress,
  };
};

export const onGetTotalShiftPatternsError = (state: ShiftPatternsState) => (action: *) => {
  return {
    ...state,
    error: action.payload,
    requestsInProgress: --state.requestsInProgress,
  };
};
// Create Shift Patterns

export const onSetShiftPattern = (state: ShiftPatternsState) => ({ payload }: Object) => ({
  ...state,
  current: payload,
});

export const onNewShiftPattern = (state: ShiftPatternsState) => (action: Action<void>) =>
  onSetShiftPattern(state)({ payload: { name: null, shiftPatternDays: [] } });

// Modals

export const onSetShowAddModal = (state: ShiftPatternsState) => ({ payload }: Object) => ({
  ...state,
  modals: {
    ...state.modals,
    showAddModal: payload,
  },
});

export const onSetShowEditModal = (state: ShiftPatternsState) => ({ payload }: Object) => ({
  ...state,
  modals: {
    ...state.modals,
    showEditModal: payload,
  },
});

export const onSetShowDeleteModal = (state: ShiftPatternsState) => ({ payload }: Object) => ({
  ...state,
  modals: {
    ...state.modals,
    showDeleteModal: payload,
  },
});

export const onToggleUnassignReassignItemsToShiftPatternModal = (state: ShiftPatternsState) => ({
  payload,
}: Object) => ({
  ...state,
  modals: {
    ...state.modals,
    reassignItemsToShiftPatternModal: {
      ...state.modals.reassignItemsToShiftPatternModal,
      visible: payload,
    },
  },
});

export const onUnassignReassignShiftPatternModal = (state: ShiftPatternsState) => ({
  payload,
}: Object) => ({
  ...state,
  modals: {
    ...state.modals,
    unassignReassignShiftPatternModal: {
      visible: payload.visible,
      shiftPattern: payload.shiftPattern || null,
      type: payload.type || null,
    },
  },
});

export const onGetEmployeePositionsAssignedToShiftPattern = (state: ShiftPatternsState) => () =>
  startRequest(state);

export const onGetEmployeePositionsAssignedToShiftPatternSuccess = (state: ShiftPatternsState) => ({
  payload,
}: Object) => ({
  ...state,
  ...finishRequest(state),
  employeePositionsAssignedToShiftPattern: payload,
});

export const onGetEmployeePositionsAssignedToShiftPatternError = (state: ShiftPatternsState) => ({
  payload,
}: Object) => ({
  ...state,
  ...finishRequest(state),
  error: payload,
});

export const onGetDepartmentsAssignedToShiftPattern = (state: ShiftPatternsState) => () =>
  startRequest(state);

export const onGetDepartmentsAssignedToShiftPatternSuccess = (state: ShiftPatternsState) => ({
  payload,
}: Object) => ({
  ...state,
  ...finishRequest(state),
  departmentsAssignedToShiftPattern: payload,
});

export const onGetDepartmentsAssignedToShiftPatternError = (state: ShiftPatternsState) => ({
  payload,
}: Object) => ({
  ...state,
  ...finishRequest(state),
  error: payload,
});

export const onUpdateShiftPatternDraft = (state: ShiftPatternsState) => ({ payload }: Object) => ({
  ...state,
  draft: payload,
});
